import { Component, HostListener, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  imports: [CommonModule ],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent {
  @Input() currentStep = 1;
  @Input() user: any;
  @Input() percentageComplete = 0; 
  isResponsive: boolean = false;

  constructor(private router: Router) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkResponsive();
  }

  avanzar() {
    if (this.currentStep < 3) {
      this.currentStep++;
    }
  }

  ngOnInit() {
    this.checkResponsive();
  }

  private checkResponsive() {
    this.isResponsive = window.innerWidth <= 768;
  }

  stepResponsive(numberStep: number) {
    if (!this.isResponsive) return true;
    return this.currentStep === numberStep;
  }

  changeTest(step: number) {
    if(step === this.currentStep) return;
    switch (step) {
      case 1:
        this.router.navigate(['/assessment']);
        break;
      case 2:
        if(this.user.profile.testNowComplete === true) 
          this.router.navigate(['/assessment-future']);
        else return;
        break;
      case 3:
        if(this.user.profile.testNowComplete === true && this.user.profile.testFutureComplete === true) 
          this.router.navigate(['/results']);
        else return;
        break;
    }
  }
}
